import type { Feature } from './types';

const title = 'REST API documentation';

const config: Feature<{ specUrl: string }> = Object.freeze({
  title,
  isEnabled: true,
  specUrl: 'https://raw.githubusercontent.com/blockscout/blockscout-api-v2-swagger/main/swagger.yaml',
});

export default config;
